import styled from "styled-components";

export const CreateFieldStyled = styled.div`
  display: flex;
  justify-content: left;
  padding-top: 8px;
  padding-bottom: 32px;
  & > .selectBox {
    margin: 0 20px 20px 0px;
    width: 100%;
    max-width: 45%;
  }
  & .MuiFilledInput-input {
    padding: 22px 18px 7px 7px;
  }
`;

export const TopBarGroupStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  margin-bottom: 30px;
  margin-top: 15px;
`;
